var _rect, _rect2, _rect3, _rect4, _path, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#1c1917"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 135,
    width: 190,
    height: 260,
    rx: 16,
    fill: "#292524",
    stroke: "#fb923c",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 105,
    width: 190,
    height: 290,
    rx: 16,
    fill: "#292524",
    stroke: "#facc15",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 165,
    width: 190,
    height: 230,
    rx: 16,
    fill: "#292524",
    stroke: "#4ade80",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 185h130M100 220h100M335 155h130M335 190h125M570 215h130M570 250h90",
    stroke: "#d6d3d1",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#fed7aa",
    fontFamily: "sans-serif",
    fontSize: 44,
    fontWeight: 700
  }, "TASKLY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#fdba74",
    fontFamily: "monospace",
    fontSize: 22
  }, "REAL-TIME KANBAN WORKSPACE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskly);
export default __webpack_public_path__ + "static/media/taskly.782a506cb5b7faa77416c36b3659a054.svg";
export { ForwardRef as ReactComponent };